// to be used outside of the trix editor
export default class SimpleCharCountdown {
  constructor(opts) {
    this.$editor    = opts['editor'];
    this.$el        = opts['element'] || $(this.$editor.data("countdown"));
    this.max_length = opts['maxLength'] || parseInt(this.$editor.attr("maxlength")) || 65535;

    this.render()
    this.listen()
  }

  listen() {
    N2.handle("input", this.$editor, () => {
      this.render()
    });
  }

  render() {
    let length    = this.$editor.val().length
    let isOver    = length > this.max_length
    let truncate  = null

    if (isOver) {
      this.trimLength()
      isOver    = false
      length    = this.max_length
    }

    let html = `
      <ul class="breadcrumb white">
        <li>${length}</li>
        <li>${this.max_length}</li>
      </ul>
    `
    this.$el.html(html)
  }

  trimLength(){
    return this.$editor.val(this.$editor.val().substring(0, this.max_length))
  }
}
